(function () {
  'use strict';

  /* ===== Tab navigation ===== */

  function ProductTabs(el) {
    this.el = el;
    this.nav = el.querySelector('.product-tabs__nav');
    if (!this.nav) return;
    this.tabs = Array.from(this.nav.querySelectorAll('.product-tabs__tab'));
    this._bindEvents();
  }

  ProductTabs.prototype._bindEvents = function () {
    var self = this;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        self._activate(tab);
      });
    });

    this.nav.addEventListener('keydown', function (e) {
      self._onKeydown(e);
    });
  };

  ProductTabs.prototype._onKeydown = function (e) {
    var currentTab = this.nav.querySelector('[aria-selected="true"]');
    var idx = this.tabs.indexOf(currentTab);
    var len = this.tabs.length;
    var next;

    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        next = (idx + 1) % len;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        next = (idx - 1 + len) % len;
        break;
      case 'Home':
        e.preventDefault();
        next = 0;
        break;
      case 'End':
        e.preventDefault();
        next = len - 1;
        break;
      default:
        return;
    }

    this._activate(this.tabs[next]);
    this.tabs[next].focus();
  };

  ProductTabs.prototype._activate = function (tab) {
    var self = this;

    this.tabs.forEach(function (t) {
      t.classList.remove('product-tabs__tab--active');
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    });

    this.el.querySelectorAll('.product-tabs__panel').forEach(function (panel) {
      panel.classList.remove('product-tabs__panel--active');
    });

    tab.classList.add('product-tabs__tab--active');
    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');

    var panel = document.getElementById(tab.getAttribute('aria-controls'));
    if (panel) panel.classList.add('product-tabs__panel--active');
  };

  function initTabs(scope) {
    (scope || document).querySelectorAll('.product-tabs').forEach(function (el) {
      new ProductTabs(el);
    });
  }

  /* ===== Cocktail recipe slider ===== */

  function _startSlider(grid) {
    if (grid._flkty) return;

    grid._flkty = new Flickity(grid, {
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: false
    });

    var panel = grid.closest('.collapsible-content');
    if (panel && !panel.classList.contains('is-open')) {
      var obs = new MutationObserver(function () {
        if (!panel.classList.contains('is-open')) return;
        function onTransitionEnd(e) {
          if (e.propertyName !== 'max-height') return;
          panel.removeEventListener('transitionend', onTransitionEnd);
          if (grid._flkty) grid._flkty.resize();
        }
        panel.addEventListener('transitionend', onTransitionEnd);
      });
      obs.observe(panel, { attributes: true, attributeFilter: ['class'] });
      grid._panelObserver = obs;
    }
  }

  function _stopSlider(grid) {
    if (grid._flkty) { grid._flkty.destroy(); grid._flkty = null; }
    if (grid._panelObserver) { grid._panelObserver.disconnect(); grid._panelObserver = null; }
  }

  function initCocktailSliders(scope) {
    if (typeof Flickity === 'undefined') return;
    var mq = window.matchMedia('(max-width: 768px)');
    (scope || document).querySelectorAll('.cocktail-grid').forEach(function (grid) {
      mq.matches ? _startSlider(grid) : _stopSlider(grid);
    });
  }

  // React only when the breakpoint is actually crossed — Flickity handles
  // in-range resize internally, so we don't need to call resize() ourselves.
  window.matchMedia('(max-width: 768px)').addEventListener('change', function (e) {
    document.querySelectorAll('.cocktail-grid').forEach(function (grid) {
      e.matches ? _startSlider(grid) : _stopSlider(grid);
    });
  });

  /* ===== Radar chart ===== */

  function hexToRgba(hex, alpha) {
    var clean = hex.replace(/\s/g, '').replace('#', '');
    if (clean.length === 3) {
      clean = clean[0] + clean[0] + clean[1] + clean[1] + clean[2] + clean[2];
    }
    if (clean.length !== 6) return 'rgba(0,0,0,' + alpha + ')';
    var r = parseInt(clean.slice(0, 2), 16);
    var g = parseInt(clean.slice(2, 4), 16);
    var b = parseInt(clean.slice(4, 6), 16);
    return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
  }

  function buildChart(canvas) {
    var root = getComputedStyle(document.documentElement);
    var primaryColor  = root.getPropertyValue('--colorBtnPrimary').trim();
    var borderColor   = root.getPropertyValue('--colorBorder').trim();
    var textColor     = root.getPropertyValue('--colorTextBody').trim();
    var headerFont    = root.getPropertyValue('--typeHeaderPrimary').trim() + ', sans-serif';

    function metaVal(str, fb) { var n = parseFloat(str); return isNaN(n) ? fb : n; }
    var values = [
      metaVal(canvas.dataset.sweet,  5),
      metaVal(canvas.dataset.smoky,  5),
      metaVal(canvas.dataset.fruity, 5),
      metaVal(canvas.dataset.spicy,  5),
      metaVal(canvas.dataset.briny,  5),
      metaVal(canvas.dataset.round,  5)
    ];

    new Chart(canvas, {
      type: 'radar',
      data: {
        labels: [
          canvas.dataset.labelSweet,
          canvas.dataset.labelSmoky,
          canvas.dataset.labelFruity,
          canvas.dataset.labelSpicy,
          canvas.dataset.labelBriny,
          canvas.dataset.labelRound
        ],
        datasets: [{
          data: values,
          backgroundColor: hexToRgba(primaryColor, 0.1),
          borderColor: primaryColor,
          pointBackgroundColor: primaryColor,
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: primaryColor,
          borderWidth: 2,
          pointRadius: 4,
          pointHoverRadius: 6
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          r: {
            beginAtZero: true,
            min: 0,
            max: 5,
            ticks: {
              display: false,
              stepSize: 1
            },
            grid: { color: borderColor },
            angleLines: { color: borderColor },
            pointLabels: {
              color: textColor,
              font: { family: headerFont, size: 13 }
            }
          }
        },
        plugins: {
          legend: { display: false }
        }
      }
    });

    var wrap = canvas.closest('.tasting-chart-wrap');
    if (wrap) wrap.style.opacity = '1';
  }

  window.initTastingCharts = function () {
    if (typeof Chart === 'undefined') return;
    document.querySelectorAll('.tasting-chart:not([data-chart-init])').forEach(function (canvas) {
      canvas.dataset.chartInit = '1';
      buildChart(canvas);
    });
  };

  /* ===== Init ===== */

  document.addEventListener('DOMContentLoaded', function () {
    initTabs();
    initCocktailSliders();
    if (window.chartJsLoaded) window.initTastingCharts();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initTabs(e.target);
    initCocktailSliders(e.target);
    if (window.chartJsLoaded) window.initTastingCharts();
  });

  document.addEventListener('shopify:block:select', function (e) {
    if (e.target.querySelector('.tasting-chart')) {
      if (window.chartJsLoaded) window.initTastingCharts();
    }
  });
})();
